import type { AppRouteKey } from "../platform/app-metadata";

export const DASHBOARD_AREA_KEYS = ["inventory", "transactions", "orders", "contacts", "audit", "users"] as const satisfies readonly AppRouteKey[];

export type DashboardAreaKey = (typeof DASHBOARD_AREA_KEYS)[number];
export type DashboardEndpointKey<K extends DashboardAreaKey = DashboardAreaKey> = `dashboard${Capitalize<K>}`;

export function dashboardEndpointKey<K extends DashboardAreaKey>(area: K): DashboardEndpointKey<K> {
  return `dashboard${area.charAt(0).toUpperCase()}${area.slice(1)}` as DashboardEndpointKey<K>;
}

export function isDashboardAreaKey(value: string): value is DashboardAreaKey {
  return (DASHBOARD_AREA_KEYS as readonly string[]).includes(value);
}
